import { SceneUtilsService } from '../scene-utils.service';
import { Injectable } from '@angular/core';
import { common } from './common';

@Injectable()
export class PositionCalculatorService {
  constructor(private sceneUtils: SceneUtilsService) {}

  calculate(e: MouseEvent) {
    const raycaster = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    return raycaster.ray.origin.setY(common.startAtY);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/position-calculator.service.ts